<template>
  <div class="form-number-input form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="disabled"
      >
        <x-number-input
          v-if="renderSence === 'edit'"
          :disabled="disabled"
          v-model="formValue"
          :placeholder="placeholder"
          :decimalNum="widget.decimalNum"
          :tabindex="tabindex"
          @change="change"
        ></x-number-input>
        <span v-if="renderSence === 'read'">{{ formValue || '-' }}</span>
      </x-proxy-form-item>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import WidgetRangeValidator from '../../../form-validator/widget-range-validator'

export default {
  name: 'FormNumberInput',
  mixins: [FormWidgetConfigMixin],
  watch: {
    'widget.numberMin': {
      handler(newValue, oldValue) {
        this.widgetRules = [
          this._validate(WidgetRangeValidator(newValue, this.widget.numberMax, `数字`))
        ]
      },
      immediate: true
    },
    'widget.numberMax': {
      handler(newValue, oldValue) {
        this.widgetRules = [
          this._validate(WidgetRangeValidator(this.widget.numberMin, newValue, `数字`))
        ]
      },
      immediate: true
    }
  },
  computed: {
    placeholder() {
      return this.widget.enableRule 
        ? '自动计算'
        : this.widget.readOnly 
          ? '' 
          : this.widget.placeholder
    },
    disabled() {
      return this.widget.enableRule || this.widget.readOnly
    }
  },
  methods: {
    change(e) {
      this.formValue = e ? parseFloat(e) : undefined
    }
  }
}
</script>

<style lang="scss">
.form-number-input {
  background-color: $--app-light-color;

  .form-item-label {
    font-size: $--app-title-font-size;
    line-height: 1;
    display: flex;
    font-weight: $--app-base-font-weight;
  }
  .form-item-content {
    z-index: 1;
    position: relative;
    .form-input {
      .cube-input {
        border: 0;
        .cube-input-field {
          font-size: $--app-title-font-size;
        }
      }
      .cube-input::after {
        border: 0;
      }
      .cube-input_active::after {
        border: 0;
      }
    }
  }
  .readonly-background {
    background-color: $--app-form-readonly-bgColor !important;

    .cube-input {
      background-color: $--app-form-readonly-bgColor !important;
      color: $--app-base-font-color !important;
      input:disabled {
        opacity: 1;
      }
    }

    .cube-input-field {
      background-color: $--app-form-readonly-bgColor !important;
      color: $--app-base-font-color !important;
    }
  }
}
</style>